export var DEFAULT_MODAL_ANIMATION_TYPE = 'scale';
export var DEFAULT_MODAL_ANIMATION_DURATION = 300;
export var DEFAULT_MODAL_ANIMATION = {
  animation: DEFAULT_MODAL_ANIMATION_TYPE,
  duration: DEFAULT_MODAL_ANIMATION_DURATION
};
export var FADE_IN_DOCUMENT_CLASS = 'modal-fade-in';